import { useEffect, useState } from "react";
import { webApi } from "@/lib/webApi";

export const useThriftCutouts = (count) => {
  const [map, setMap] = useState({});
  useEffect(() => {
    if (!count) return undefined;
    let alive = true;
    let tries = 0;
    let timer;
    const load = () =>
      webApi.get("/thrift/cutouts").then(({ data }) => {
        if (!alive) return;
        setMap(data);
        if (Object.values(data).some((c) => c.status === "pending") && ++tries < 8) timer = setTimeout(load, 7000);
      }).catch(() => {});
    load();
    return () => { alive = false; clearTimeout(timer); };
  }, [count]);
  const base = process.env.REACT_APP_BACKEND_URL;
  return (item) => {
    const c = map[item.id];
    return c?.url && c.source === item.images?.[0] ? `${base}${c.url}` : null;
  };
};
